"use client";

import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Booking() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const tastingNotes = [{
    label: "Revenue Growth"
  }, {
    label: "OTA Strategy"
  }, {
    label: "Data Analytics"
  }];
  const stats = [{
    label: "Audit",
    value: "Free"
  }, {
    label: "Focus",
    value: "ROI"
  }, {
    label: "Expert",
    value: "Sunil"
  }];
  return <section data-section-id="2930" id="bookingoptimization" className="bg-background text-foreground relative w-full overflow-hidden py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-16 lg:gap-20 items-center">
          {}
          <div ref={imageRef} className={`relative md:-my-16 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative group">
              <div className="absolute inset-0 bg-secondary/10 blur-3xl rounded-lg" aria-hidden="true" />
              <div className="relative overflow-hidden rounded-lg bg-muted/40">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/revenue_consulting_strategy.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/revenue_consulting_strategy.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/revenue_consulting_strategy.png-wvc-sizes" alt="Sunil Singh reviewing hotel revenue data on a professional dashboard" loading="lazy" decoding="async" className="w-full h-auto object-cover transition-transform duration-700 ease-out group-hover:-translate-y-2" />
              </div>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`flex flex-col transition-all duration-1000 ease-out delay-150 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="mb-6">
              <span className="font-default text-xs uppercase tracking-widest text-secondary">
                Expert Revenue Management — 2025 Strategy
              </span>
            </div>

            {}
            <h2 className="font-default font-bold text-5xl md:text-6xl lg:text-[80px] leading-[0.95] tracking-tight mb-8">
              Maximize Your Revenue
            </h2>

            {}
            <div className="flex flex-wrap gap-2.5 mb-8">
              {tastingNotes.map((note, i) => <Badge key={note.label} data-index={i} variant="outline" className="rounded-lg border-secondary/40 bg-transparent text-foreground px-4 py-1.5 text-xs font-normal font-default tracking-wide">
                  {note.label}
                </Badge>)}
            </div>

            {}
            <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground mb-10 max-w-xl">
              Unlock your property's full potential with data-driven OTA strategies and expert revenue management. We help hotel owners and investors optimize demand, increase direct bookings, and streamline tech stacks for sustainable growth.
            </p>

            {}
            <div className="flex items-center gap-3 md:gap-4 mb-10 flex-wrap">
              {stats.map((stat, i) => <div key={stat.label} data-index={i} className="flex items-center gap-3 md:gap-4">
                  {i > 0 && <span className="text-muted-foreground/60" aria-hidden="true">·</span>}
                  <div className="flex items-baseline gap-2">
                    <span className="font-default text-xs uppercase tracking-widest text-muted-foreground">
                      {stat.label}
                    </span>
                    <span className="font-default text-base font-medium text-foreground">
                      {stat.value}
                    </span>
                  </div>
                </div>)}
            </div>

            {}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-6">
              <Button asChild size="lg" className="rounded-lg bg-secondary text-white hover:bg-secondary/90 px-8 py-6 h-auto text-base font-default font-medium">
                <Link to="/ContactPage">Book a Consultation</Link>
              </Button>
              <Button asChild variant="link" className="text-foreground hover:text-secondary px-0 h-auto font-default text-base group">
                <Link to="/OurServicesPage" className="inline-flex items-center gap-2">
                  View Our Services
                  <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}